import React from 'react';
import { InstagramIcon, Music2Icon } from 'lucide-react';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
import { ScrollReveal } from '../ui/ScrollReveal';
export function SocialBanner() {
  const placeholders = ['UGC / customer photo 1', 'UGC / customer photo 2', 'UGC / customer photo 3', 'UGC / customer photo 4', 'UGC / customer photo 5'];
  return <section className="py-20 overflow-hidden" style={{
    background: 'repeating-linear-gradient(90deg, #F0B0C8 0px, #F0B0C8 20px, #F8C8DC 20px, #F8C8DC 40px)'
  }} data-id="element-80">
      <div className="container mx-auto px-4 md:px-8 mb-12 text-center" data-id="element-81">
        <ScrollReveal data-id="element-82">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D1A1A] mb-2" data-id="element-83">
            Stacked in Butter
          </h2>
          <p className="font-body text-[#E91E8C] font-medium text-lg" data-id="element-84">
            #ButterBlonde
          </p>
        </ScrollReveal>
      </div>

      <ScrollReveal direction="up" delay={200} data-id="element-85">
        {/* Horizontal scrolling row */}
        <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar pb-8 px-4 md:px-8 gap-4 md:gap-6" data-id="element-86">
          {placeholders.map((label, idx) => <div key={idx} className="snap-center shrink-0 w-[280px] md:w-[320px]" data-id="element-87">
              <ImagePlaceholder label={label} aspectRatio="square" className="hover:scale-105 transition-transform duration-500 cursor-pointer" data-id="element-88" />
            </div>)}
        </div>
      </ScrollReveal>

      <div className="container mx-auto px-4 mt-8 text-center" data-id="element-89">
        <ScrollReveal delay={400} data-id="element-90">
          <div className="flex flex-col items-center justify-center" data-id="element-91">
            <p className="font-body font-bold text-[#2D1A1A] mb-4" data-id="element-92">
              Follow us @butterblonde
            </p>
            <div className="flex space-x-4" data-id="element-93">
              <a href="#" className="p-3 bg-[#FFF8F0] rounded-full text-[#6B1D4A] hover:bg-[#E91E8C] hover:text-white transition-colors shadow-sm" data-id="element-94">
                <InstagramIcon className="w-6 h-6" data-id="element-95" />
              </a>
              <a href="#" className="p-3 bg-[#FFF8F0] rounded-full text-[#6B1D4A] hover:bg-[#E91E8C] hover:text-white transition-colors shadow-sm" data-id="element-96">
                <Music2Icon className="w-6 h-6" data-id="element-97" />
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>

      <style data-id="element-98">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>;
}